class RecipientForm extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.radioInputs = Array.from(
      this.querySelectorAll('input[name="gift_card_recipient_choice"]'),
    )
    this.hiddenControlField = this.querySelector(
      `#Recipient-control-${this.dataset.sectionId}`,
    )
    this.hiddenControlField.disabled = true
    this.emailInput = this.querySelector(
      `#Recipient-email-${this.dataset.sectionId}`,
    )
    this.nameInput = this.querySelector(
      `#Recipient-name-${this.dataset.sectionId}`,
    )
    this.messageInput = this.querySelector(
      `#Recipient-message-${this.dataset.sectionId}`,
    )
    this.sendonInput = this.querySelector(
      `#Recipient-send-on-${this.dataset.sectionId}`,
    )
    this.offsetProperty = this.querySelector(
      `#Recipient-timezone-offset-${this.dataset.sectionId}`,
    )
    this.recipientCheckbox = this.querySelector(
      `#Recipient-checkbox-${this.dataset.sectionId}`,
    )
    if (this.offsetProperty) {
      this.offsetProperty.value = new Date().getTimezoneOffset()
    }

    this.errorMessageWrapper = this.querySelector('[data-error-box]')
    this.errorMessageList = this.errorMessageWrapper?.querySelector(
      '[data-error-list]',
    )
    this.errorMessage = this.errorMessageWrapper?.querySelector(
      '.gft-GiftCardRecipient_ErrorMessage',
    )
    this.defaultErrorHeader = this.errorMessage?.innerText
    this.currentProductVariantId = this.dataset.productVariantId

    this.myselfContainer = this.querySelector(
      '[data-recipient-container="myself"]',
    )
    this.recipientContainer = this.querySelector(
      '[data-recipient-container="other"]',
    )
  }

  setupListeners () {
    super.setupListeners()

    this.radioInputs.forEach(radioInput => {
      this.listeners.add(radioInput, 'change', this.onChange.bind(this))
    })

    this.updateContainers()
  }

  onChange () {
    this.updateContainers()

    if (!this.recipientIsSelected()) {
      this.clearInputFields()
      this.clearErrorMessage()
    }
  }

  recipientIsSelected () {
    return this.radioInputs.some(
      radioInput => radioInput.checked && radioInput.value === 'true',
    )
  }

  updateContainers () {
    const recipientSelected = this.recipientIsSelected()

    this.toggleContainer(this.myselfContainer, !recipientSelected)
    this.toggleContainer(this.recipientContainer, recipientSelected)

    if (recipientSelected) {
      this.enableRecipientCheckbox()
    } else {
      this.disableRecipientCheckbox()
    }

    if (this.offsetProperty) {
      this.offsetProperty.disabled = !recipientSelected
    }
  }

  toggleContainer (container, isActive) {
    if (!container) return

    container.hidden = !isActive

    container
      .querySelectorAll('input, textarea, select')
      .forEach(field => (field.disabled = !isActive))
  }

  inputFields () {
    return [
      this.emailInput,
      this.nameInput,
      this.messageInput,
      this.sendonInput,
    ]
  }

  clearInputFields () {
    this.inputFields().forEach(field => (field.value = ''))
  }

  enableRecipientCheckbox () {
    this.recipientCheckbox.disabled = false
    this.recipientCheckbox.value = true
  }

  disableRecipientCheckbox () {
    this.recipientCheckbox.disabled = true
    this.recipientCheckbox.value = false
  }

  displayErrorMessage (title, body) {
    this.clearErrorMessage()
    this.errorMessageWrapper.hidden = false
    if (typeof body === 'object') {
      this.errorMessage.innerText = this.defaultErrorHeader
      return Object.entries(body).forEach(([key, value]) => {
        const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`
        const message = `${value.join(', ')}`
        const errorMessageElement = this.querySelector(`#${errorMessageId}`)
        const errorTextElement = errorMessageElement?.querySelector(
          '.gft-GiftCardRecipient_ErrorMessage',
        )
        if (!errorTextElement) return

        if (this.errorMessageList) {
          this.errorMessageList.appendChild(this.createErrorListItem(message))
        }

        errorTextElement.innerText = `${message}.`
        errorMessageElement.removeAttribute('hidden')

        const inputElement = this[`${key}Input`]
        if (!inputElement) return

        inputElement.setAttribute('aria-invalid', true)
        inputElement.setAttribute('aria-describedby', errorMessageId)
      })
    }

    this.errorMessage.innerText = body
  }

  createErrorListItem (message) {
    const li = document.createElement('li')
    li.innerText = message
    li.className = 'gft-GiftCardRecipient_ErrorMessage'
    return li
  }

  clearErrorMessage () {
    this.errorMessageWrapper.hidden = true

    if (this.errorMessageList) this.errorMessageList.innerHTML = ''

    this.querySelectorAll('.gft-GiftCardRecipient_Error').forEach(field => {
      field.setAttribute('hidden', true)
      const textField = field.querySelector(
        '.gft-GiftCardRecipient_ErrorMessage',
      )
      if (textField) textField.innerText = ''
    })
    ;[
      this.emailInput,
      this.messageInput,
      this.nameInput,
      this.sendonInput,
    ].forEach(inputElement => {
      inputElement.setAttribute('aria-invalid', false)
      inputElement.removeAttribute('aria-describedby')
    })
  }

  resetRecipientForm () {
    if (!this.recipientIsSelected()) return

    this.radioInputs.forEach(radioInput => {
      if (radioInput.value === 'false') {
        radioInput.checked = true
      }
    })

    this.onChange()
  }
}

if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', RecipientForm)
}
